export default __webpack_public_path__ + "static/8.FinlandWay-a3d2a69f235917e1a5f4c842f0c204cf.png";